import React, { useMemo } from 'react'
import { WalletOutlined } from '@ant-design/icons'
import { Button, Flex, Modal, Typography } from 'antd'
import { useIntl } from 'react-intl'

import styles from './paymentGatewayOnboardingModal.module.scss'

const { Paragraph, Text } = Typography

const PaymentGatewayDetailModal = ({
  open,
  onCancel,
  onActivate,
  notificationId,
  activateLoading = false,
}) => {
  const { formatMessage } = useIntl()

  const footer = useMemo(
    () => [
      <Button
        key="yes"
        type="primary"
        loading={activateLoading}
        disabled={activateLoading}
        onClick={() => {
          if (notificationId && !activateLoading) {
            onActivate?.(notificationId)
          }
        }}
      >
        {formatMessage({ id: 'appOnboarding.paymentGateway.btn_yes_activate' })}
      </Button>,
      <Button key="no" danger disabled={activateLoading} onClick={onCancel}>
        {formatMessage({ id: 'appOnboarding.paymentGateway.btn_no' })}
      </Button>,
    ],
    [activateLoading, formatMessage, notificationId, onActivate, onCancel],
  )

  return (
    <Modal
      open={open}
      title={formatMessage({ id: 'appOnboarding.paymentGateway.detail_modal_title' })}
      onCancel={onCancel}
      closable={!activateLoading}
      footer={footer}
      maskClosable={false}
      keyboard={false}
      destroyOnHidden
      width={560}
      styles={{
        body: { paddingTop: 20 },
      }}
    >
      <Flex vertical gap={16}>
        <Flex justify="center" style={{ marginTop: 8, marginBottom: 4 }}>
          <div className={styles.iconWrap} aria-hidden>
            <WalletOutlined style={{ fontSize: 34, color: '#fff' }} />
          </div>
        </Flex>
        <Paragraph style={{ marginBottom: 0 }}>
          {formatMessage({ id: 'appOnboarding.paymentGateway.detail_paragraph_1' })}
        </Paragraph>
        <Paragraph style={{ marginBottom: 0 }}>
          {formatMessage({ id: 'appOnboarding.paymentGateway.detail_paragraph_2' })}
        </Paragraph>
        <Text strong>
          {formatMessage({ id: 'appOnboarding.paymentGateway.detail_confirm_question' })}
        </Text>
      </Flex>
    </Modal>
  )
}

export default PaymentGatewayDetailModal
